// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".main .holder>.line[data-v-e0498bfa]{margin-bottom:50px}.catalog-item[data-v-e0498bfa]{display:flex;flex-flow:column;height:100%}.catalog-img[data-v-e0498bfa]{height:calc(100% - 2.75em - 14px);background-color:#f5f5f5;padding:1vw;display:flex;align-items:center;justify-content:center}.catalog-img img[data-v-e0498bfa]{max-height:100%;max-width:100%;width:auto}", ""]);
// Exports
module.exports = exports;
